export enum EligibilityEmployerChoiceId {
  advantageTruckGroup = "qkD52JGcsUbO",
  airLife = "RrAoTORYaPHE",
  albar = "1fc4hYxx53KH",
  amazon = "ALXY6RYKBVTr",
  americanCollegeOfRheumatology = "OO0vMMAJzWLt",
  apple = "AjiuetUcuy5D",
  bankOfNewYork = "3zzrtfKrgXjW",
  bjs = "F8GN2UPKvArt",
  caretria = "gjJp6dJLCHwo",
  celiaCorporation = "CZsNv57BJrMB",
  demo = "TvMRqMrvfkMi",
  eptam = "wPYZDAGHVnYs",
  exceptionalMotorcars = "wbcgBT1kCY5x",
  firstChoice = "1nJ65cyhh18G",
  generalPlastics = "XXhxi0BA1XZO",
  harvardUniversity = "plJ2lDPsE06N",
  horizonHealthPartners = "djD0aDXW3ISk",
  hydacTechnologyCorporation = "KAPqVRi51kMD",
  jimSchmidtChevrolet = "TDyAAMxBXc5v",
  jjSafety = "YWlwgEuAOeI7",
  kineticGroup = "KS7beV6g2Ll7",
  kwestGroup = "g7zSaWeQqDFv",
  kwikTrip = "oZlpyMeJMxwX",
  lilly = "vVjcv17F6WlJ",
  lochmuellerGroup = "sQav0cgzyXLh",
  managementMcoa = "MZOHxK2xDhXt",
  matrixMedical = "plS9FZzLY2jT",
  noneOfTheAbove = "i1RG8jQXdqYz",
  northfieldHospitalAndClinics = "GsDzrbqqF4Zs",
  prescryptive = "xBdIqSpWXKNF",
  seveeAndMaherEngineers = "yOblIQrWH9PP",
  silverstoneLiving = "KtuJcQBWYDxx",
  sorensonCommunications = "ksfZ0BP67VOi",
  stateOfGeorgia = "vKaXxG5o0FYI",
  stateOfIndiana = "PxcU4opoCxXT",
  thermoFisherScientific = "YdKB5xM37INO",
  transcarent = "6IXsQ6iyGwxW",
  unitedDerm = "o3YJ9iNpfdw9",
  unitedTrailers = "e8Y25dGSuvTw",
  weAreBlood = "2PclwiU3z3G2",
  wickBuildings = "eZrtnWj6qwmP",
  willScot = "WwAkMplUWw4f",
  soleraPebtf = "s5o9le8r8a01"
}

export enum EligibilityQuestionId {
  employer = "nnr4MisyYRqS",
  healthPlan = "Xr1URwgDrLB8"
}

export enum EligibilityHealthPlanChoiceId {
  anthemIndiana = "nvwPwhoPWjJv",
  evernorth = "EhJryoxsCGQQ",
  cignaIfp = "WSms00VLXTju",
  solera = "s1oDlEeVr9aQ",
  transcarent = "CAEVcKrBxBvN"
}

export const eligibilityEmployerChoiceValues: {
  [key in EligibilityEmployerChoiceId]: string;
} = {
  [EligibilityEmployerChoiceId.advantageTruckGroup]: "Advantage Truck Group",
  [EligibilityEmployerChoiceId.airLife]: "AirLife",
  [EligibilityEmployerChoiceId.albar]: "Albar",
  [EligibilityEmployerChoiceId.amazon]: "Amazon",
  [EligibilityEmployerChoiceId.americanCollegeOfRheumatology]:
    "American College of Rheumatology",
  [EligibilityEmployerChoiceId.apple]: "Apple",
  [EligibilityEmployerChoiceId.bankOfNewYork]: "Bank of New York",
  [EligibilityEmployerChoiceId.bjs]: "BJ's",
  [EligibilityEmployerChoiceId.caretria]: "Caretria",
  [EligibilityEmployerChoiceId.celiaCorporation]: "Celia Corporation",
  [EligibilityEmployerChoiceId.demo]: "Demo",
  [EligibilityEmployerChoiceId.eptam]: "EPTAM",
  [EligibilityEmployerChoiceId.exceptionalMotorcars]: "Exceptional Motorcars",
  [EligibilityEmployerChoiceId.firstChoice]: "First Choice",
  [EligibilityEmployerChoiceId.generalPlastics]: "General Plastics",
  [EligibilityEmployerChoiceId.harvardUniversity]: "Harvard University",
  [EligibilityEmployerChoiceId.horizonHealthPartners]:
    "Horizon Health Partners",
  [EligibilityEmployerChoiceId.hydacTechnologyCorporation]:
    "Hydac Technology Corporation",
  [EligibilityEmployerChoiceId.jimSchmidtChevrolet]: "Jim Schmidt Chevrolet",
  [EligibilityEmployerChoiceId.jjSafety]: "JJ Safety",
  [EligibilityEmployerChoiceId.kineticGroup]: "Kinetic Group",
  [EligibilityEmployerChoiceId.kwestGroup]: "KWest Group",
  [EligibilityEmployerChoiceId.kwikTrip]: "Kwik Trip",
  [EligibilityEmployerChoiceId.lilly]: "Lilly",
  [EligibilityEmployerChoiceId.lochmuellerGroup]: "Lochmueller Group, Inc.",
  [EligibilityEmployerChoiceId.managementMcoa]: "Management MCOA",
  [EligibilityEmployerChoiceId.matrixMedical]: "Matrix Medical",
  [EligibilityEmployerChoiceId.noneOfTheAbove]: "None of the above",
  [EligibilityEmployerChoiceId.northfieldHospitalAndClinics]:
    "Northfield Hospital and Clinics",
  [EligibilityEmployerChoiceId.prescryptive]: "Prescryptive",
  [EligibilityEmployerChoiceId.seveeAndMaherEngineers]:
    "Sevee & Maher Engineers",
  [EligibilityEmployerChoiceId.silverstoneLiving]: "Silverstone Living",
  [EligibilityEmployerChoiceId.sorensonCommunications]:
    "Sorenson Communications, LLC",
  [EligibilityEmployerChoiceId.stateOfGeorgia]: "SHBP State of Georgia",
  [EligibilityEmployerChoiceId.stateOfIndiana]: "State of Indiana",
  [EligibilityEmployerChoiceId.thermoFisherScientific]:
    "Thermo Fisher Scientific",
  [EligibilityEmployerChoiceId.transcarent]: "Transcarent",
  [EligibilityEmployerChoiceId.unitedDerm]: "United Derm",
  [EligibilityEmployerChoiceId.unitedTrailers]: "United Trailers",
  [EligibilityEmployerChoiceId.weAreBlood]: "We Are Blood",
  [EligibilityEmployerChoiceId.wickBuildings]: "Wick Buildings",
  [EligibilityEmployerChoiceId.willScot]: "WillScot",
  [EligibilityEmployerChoiceId.soleraPebtf]: "PEBTF"
};

export const eligibilityHealthPlanChoiceValues = {
  [EligibilityHealthPlanChoiceId.anthemIndiana]: "Anthem Indiana",
  [EligibilityHealthPlanChoiceId.evernorth]: "Evernorth",
  [EligibilityHealthPlanChoiceId.cignaIfp]: "Cigna IFP",
  [EligibilityHealthPlanChoiceId.solera]: "Solera",
  [EligibilityHealthPlanChoiceId.transcarent]: "Transcarent"
};
